(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nq-closing-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSwatches(root) {
    root.querySelectorAll('[data-nqc-sw]').forEach(function (row) {
      if (row.dataset.nqcBound === '1') return;
      row.dataset.nqcBound = '1';

      var card = row.closest('[data-nqc-card]');
      var nameEl = row.querySelector('[data-nqc-sw-name]');
      var mainImg = card ? card.querySelector('[data-nqc-main]') : null;

      function pick(sw) {
        row.querySelectorAll('.nqc-card__sw').forEach(function (el) {
          el.classList.toggle('is-on', el === sw);
        });
        if (nameEl) nameEl.textContent = sw.dataset.swName || '';
        if (mainImg && sw.dataset.swImg) {
          mainImg.removeAttribute('srcset');
          mainImg.src = sw.dataset.swImg;
        }
        if (card && sw.dataset.swUrl) card.setAttribute('href', sw.dataset.swUrl);
      }

      row.querySelectorAll('.nqc-card__sw').forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          pick(sw);
        });
        sw.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            pick(sw);
          }
        });
      });
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-nqc-carousel]').forEach(function (track) {
      if (track.dataset.nqcBound === '1') return;
      track.dataset.nqcBound = '1';

      var media = track.parentElement;
      var dots = media ? media.querySelectorAll('.nqc-card__dot') : [];
      if (!dots.length) return;

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          dots.forEach(function (d, n) {
            d.classList.toggle('nqc-card__dot--on', n === i);
          });
        });
      }, { passive: true });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.nq-closing').forEach(function (sec) {
      initSwatches(sec);
      initCarousels(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nq-collection-promo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function nextMidnight() {
    var d = new Date();
    d.setHours(24, 0, 0, 0);
    return d.getTime();
  }

  function rollingTarget(hours) {
    var span = hours * 3600000;
    if (!span) span = 3600000;
    var now = Date.now();
    return Math.ceil(now / span) * span;
  }

  function initTimer(el) {
    if (el.dataset.nqcBound === '1') return;
    el.dataset.nqcBound = '1';

    var h = el.querySelector('[data-h]');
    var m = el.querySelector('[data-m]');
    var s = el.querySelector('[data-s]');
    var mode = el.dataset.mode || 'midnight';
    var fixed = Date.parse(el.dataset.deadline || '');
    var hours = parseFloat(el.dataset.hours || '3');

    function target() {
      if (mode === 'fixed' && !isNaN(fixed)) return fixed;
      if (mode === 'rolling') return rollingTarget(hours);
      return nextMidnight();
    }

    function tick() {
      var left = Math.max(0, target() - Date.now());
      var total = Math.floor(left / 1000);
      if (h) h.textContent = pad(Math.floor(total / 3600));
      if (m) m.textContent = pad(Math.floor((total % 3600) / 60));
      if (s) s.textContent = pad(total % 60);
    }

    tick();
    window.setInterval(tick, 1000);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-nqc-timer]').forEach(initTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nq-main-collection"]) return;
  try {
    
(function () {
  function initSwatches(root) {
    root.querySelectorAll('[data-nqc-sw]').forEach(function (row) {
      if (row.dataset.nqcBound === '1') return;
      row.dataset.nqcBound = '1';

      var card = row.closest('[data-nqc-card]');
      var nameEl = row.querySelector('[data-nqc-sw-name]');
      var mainImg = card ? card.querySelector('[data-nqc-main]') : null;

      function pick(sw) {
        row.querySelectorAll('.nqc-card__sw').forEach(function (el) {
          el.classList.toggle('is-on', el === sw);
        });
        if (nameEl) nameEl.textContent = sw.dataset.swName || '';
        if (mainImg && sw.dataset.swImg) {
          mainImg.removeAttribute('srcset');
          mainImg.src = sw.dataset.swImg;
        }
        if (card && sw.dataset.swUrl) card.setAttribute('href', sw.dataset.swUrl);
      }

      row.querySelectorAll('.nqc-card__sw').forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          pick(sw);
        });
        sw.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            pick(sw);
          }
        });
      });
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-nqc-carousel]').forEach(function (track) {
      if (track.dataset.nqcBound === '1') return;
      track.dataset.nqcBound = '1';

      var media = track.parentElement;
      var dots = media ? media.querySelectorAll('.nqc-card__dot') : [];
      if (!dots.length) return;

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          dots.forEach(function (d, n) {
            d.classList.toggle('nqc-card__dot--on', n === i);
          });
        });
      }, { passive: true });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.nqc').forEach(function (sec) {
      initSwatches(sec);
      initCarousels(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nq-xsell-educativa"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSwatches(root) {
    root.querySelectorAll('[data-nqc-sw]').forEach(function (row) {
      if (row.dataset.nqcBound === '1') return;
      row.dataset.nqcBound = '1';

      var card = row.closest('[data-nqc-card]');
      var nameEl = row.querySelector('[data-nqc-sw-name]');
      var mainImg = card ? card.querySelector('[data-nqc-main]') : null;

      function pick(sw) {
        row.querySelectorAll('.nqc-card__sw').forEach(function (el) {
          el.classList.toggle('is-on', el === sw);
        });
        if (nameEl) nameEl.textContent = sw.dataset.swName || '';
        if (mainImg && sw.dataset.swImg) {
          mainImg.removeAttribute('srcset');
          mainImg.src = sw.dataset.swImg;
        }
        if (card && sw.dataset.swUrl) card.setAttribute('href', sw.dataset.swUrl);
      }

      row.querySelectorAll('.nqc-card__sw').forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          pick(sw);
        });
        sw.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            pick(sw);
          }
        });
      });
    });
  }

  function initCarousels(root) {
    root.querySelectorAll('[data-nqc-carousel]').forEach(function (track) {
      if (track.dataset.nqcBound === '1') return;
      track.dataset.nqcBound = '1';

      var media = track.parentElement;
      var dots = media ? media.querySelectorAll('.nqc-card__dot') : [];
      if (!dots.length) return;

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = null;
          var w = track.clientWidth || 1;
          var i = Math.round(track.scrollLeft / w);
          dots.forEach(function (d, n) {
            d.classList.toggle('nqc-card__dot--on', n === i);
          });
        });
      }, { passive: true });
    });
  }

  function initArrows(root) {
    root.querySelectorAll('.nq-xsell__slider').forEach(function (slider) {
      if (slider.dataset.nqArrows === '1') return;
      slider.dataset.nqArrows = '1';

      var track = slider.querySelector('.nq-xsell__track');
      var prev = slider.querySelector('.nq-xsell__arr--prev');
      var next = slider.querySelector('.nq-xsell__arr--next');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.querySelector('.nqc-card');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });

      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(sync);
      }, { passive: true });

      window.addEventListener('resize', sync);
      sync();
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.nq-xsell').forEach(function (sec) {
      initSwatches(sec);
      initCarousels(sec);
      initArrows(sec);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
